export default {
  data() {
    return {
      webAppUpdate: {
        exists: false, // does update exist
        refreshing: false, // is refreshing ongoing
        registration: null, // sw registration
      },
      electronUpdate: {
        available: false, // is update available
        downloaded: false, // has update finished downloading
      },
      notificationDisplayed: false,
    };
  },

  created() {
    // Listen for electron updates
    this.setupElectronUpdate();

    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.handleWebppUpdateIsAvailable, { once: true });
  },

  methods: {
    // Setup listeners for electron app updates and update data accordingly
    setupElectronUpdate() {
      const electronAPI = window.electron;
      if (!this.isElectronApp || !electronAPI) return;

      // Setup channel to recieve current state of electron update
      electronAPI.on('update-state-channel', (_, state) => {
        this.handleSetElectronUpdateState(state);
      });

      // Manually fetch update state of the electron app
      electronAPI.send('check-update-channel');
    },

    // Store the SW registration so we can send it a message
    // We use `webAppUpdate.exists` to control whatever alert, toast, dialog, etc we want to use
    // To alert the user there is an update they need to refresh for
    handleWebppUpdateIsAvailable(event) {
      this.webAppUpdate.registration = event.detail;
      this.webAppUpdate.exists = true;
    },

    // Set electron update state
    handleSetElectronUpdateState(state) {
      this.electronUpdate = state;
    },

    // Called when the user accepts the web app update
    updateWebApp() {
      this.webAppUpdate.exists = false;
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.webAppUpdate.registration || !this.webAppUpdate.registration.waiting) return;

      // Prevent multiple refreshes and attach listener only at this point
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.webAppUpdate.refreshing) return;
        this.webAppUpdate.refreshing = true;
        // Here the actual reload of the page occurs
        window.location.reload();
      });

      // send message to SW to skip the waiting and activate the new SW
      this.webAppUpdate.registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    },

    // Called when the user accepts the electron update
    updateElectron() {
      window.electron.send('apply-update-channel');
    },

    update() {
      // Handle updating web app if available
      if (this.webAppUpdate.exists) {
        this.updateWebApp();
      }

      // Handle updating electron if available
      if (this.electronUpdate.available && this.electronUpdate.downloaded) {
        this.updateElectron();
      }
    },

    openChangeLog() {
      window.open(this.$constants.changelogUrl, '_blank');
    },

    displayNotification() {
      if (this.notificationDisplayed) return;

      // If there is a web app update but electron app update is currently downloading,
      // wait for the download to finish and let watcher for electron update handle displaying notification.
      if (
        this.webAppUpdate.exists &&
        this.electronUpdate.available &&
        !this.electronUpdate.downloaded
      ) {
        return;
      }

      const notificationLabels = [
        {
          text: this.translate('update'),
          type: this.$constants.uiNotificationElements.button,
          callback: () => {
            this.notificationDisplayed = false;
            this.update();
          },
          buttonStyle: 'attention',
        },
        {
          text: `${this.translate('whatsNew')}?`,
          type: this.$constants.uiNotificationElements.button,
          callback: this.openChangeLog,
          buttonStyle: 'important',
          isChangeLogButton: true,
        },
      ];

      this.notificationDisplayed = true;
      this.$store.dispatch('addUiNotification', {
        icon: 'rocket',
        message: this.translate('NewVersionAvailable'),
        duration: -1,
        dismissible: true,
        dismissCallback: () => {
          this.notificationDisplayed = false;
          this.update();
        },
        labels: notificationLabels,
      });
    },
  },
  watch: {
    'webAppUpdate.exists': {
      handler(newVal, oldVal) {
        if (newVal && !oldVal) {
          this.displayNotification();
        }
      },
    },
    electronUpdate(newVal) {
      if (newVal.available && newVal.downloaded) this.displayNotification();
    },
  },
};
